import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import style from './Survey_26.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { styled } from '@mui/material/styles';
import LinearProgress, {linearProgressClasses,} from '@mui/material/LinearProgress';
import URL from "../../../../../constants/url";
import SurveyMain from '../../../../../components/comsurvey/SurveyMain';
import SurveyCheckList from '../../../../../components/comsurvey/SurveyCheckList';
import ToastPopup from '../../../../../components/comm/ToastPopup';
import Modal from '../../../../../components/comm/Modal';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import data_26 from './data_26.json';


//상위 스텝 바 
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}));

const Survey_26 = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const item = location.state?.item;
    
    const [step, setStep] = useState(0);  // 0 = "설문 메인페이지"
    const [selectedValues, setSelectedValues] = useState({});
    const [toast, setToast] = useState(false);

    //전송중 체크
    const isSendingRef = useRef(false);    
    const [isLoading, setIsLoading] = useState(false);   //로딩
    const [finishOpen, setFinishOpen] = useState(false);    // 제출 모달창
    const [backConfirmOpen, setBackConfirmOpen] = useState(false);  // 뒤로가기 확인 창
    const [continueModalOpen, setContinueModalOpen] = useState(false);

    const survey_data = data_26[0];
    const outline = survey_data.outline;
    const surveyList = survey_data.surveyList;
    const totalSteps = surveyList.length;  // 설문 항목 개수

    // 작성시작 안내 메시지 표시
    const [showIntro, setShowIntro] = useState(false); 
    const [fadeOut, setFadeOut] = useState(false);

    //뒤로가기 
    const handleBackClick = () => {
        if (step === 0) {
            navigate(-1);
            return;
        }
        setBackConfirmOpen(true);
    };
    // 뒤로가기 클릭 시 현재까지 내용 임시저장
    const handleConfirmBack = () => {
        setBackConfirmOpen(false);
        if (Object.keys(selectedValues).length === 0) {
            navigate(URL.HOME_CARE_MAIN, { replace: true });
            return;    // 작성된 설문이 없으면 제출 x
        };
        handleSubmit(true);
        navigate(URL.HOME_CARE_MAIN, { replace: true });
    };
    const fetchedRef = useRef(false);

    //중복방지 조회
    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        fetchSubmittedData();
    }, []);

    // 제출기록 조회
    const fetchSubmittedData = async () => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        console.log("========> usrSrveyRsltId: ", location.state?.usrSrveyRsltId);
        const url = "/homecare/srvey/retrieveUsrSrveySbmtList"
        const jToken = localStorage.getItem('jToken');
        const findItemByQesitmNo = (qesitmNo) => {
            for (const category of surveyList) {
                for (const item of category.items) {
                    if (Number(item.id) === Number(qesitmNo)) {
                        return item;
                    }
                }
            }
            return null;
        };
        const reqBody = {
                    usrSrveyRsltId: item.usrSrveyRsltId
                };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            const resultList = res.data.result.resultList || [];
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                // selectedValues 초기값 구성
                const selectedMap = {};
                resultList.forEach(ans => {
                    const item = findItemByQesitmNo(ans.qesitmNo);
                    if (item) {
                        selectedMap[item.name] = {
                            value: Array.isArray(ans.answrArry) ? ans.answrArry[0] : ans.answrArry,
                            markVal: ans.markVal
                    }; 
                    }
                });
                setSelectedValues(selectedMap);

                const hasValidAnswer = resultList.some(ans => ans.markVal !== -1);

                if (hasValidAnswer) {
                    setContinueModalOpen(true);
                }
            } else {
                alert(res.data.resultMessage);
            }
            
        } catch (err) {
            console.error("제출기록 조회 중 오류", err);
        }
    };
    
    const handleChange = (e, markVal) => {
        const name = e.target.name;
        const value = e.target.value;

        setSelectedValues((prev) => {
            const currentValue = prev[name]?.value;
            // 같은 값을 다시 클릭 → 선택 해제
            if (currentValue === value) {
                return {
                    ...prev,
                    [name]: { value: null, markVal: -1 }
                };
            }
            // 새 값 선택
            return {
                ...prev,
                [name]: { value, markVal }
            };
        });
    };

    const handleNext = () => {
        if (step < totalSteps) {
            setStep(step + 1);
        } else if (step === totalSteps) {
             setFinishOpen(true); 
        }
    };

    const handlePre = () => {
        setStep(step - 1);
    };


    const cancelModal = () => {
        setFinishOpen(false)
    }
    
    const buildSubmitRequest = () => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        return {
            usrSrveyRsltId: item.usrSrveyRsltId,
            answrList: surveyList.flatMap((category) =>
                category.items.map((item) => {
                    const selected = selectedValues[item.name] || {};
                    const value = selected.value;

                    let markVal;
                    if (!selected.value) {
                        markVal = item.required === false ? 0 : -1;
                    } else {
                        markVal = selected.markVal ?? -1;
                    }

                    return {
                        qesitmNo: Number(item.id),
                        qesitmCn: item.question,
                        qesitmSeCd: item.type === 'single' ? '1' : item.type === 'multi' ? '2' : '3',
                        answrArry: Array.isArray(value) ? value : [value],
                        markVal
                    };
                })
            )
        };
    };
    // 제출 내용 저장
    const handleSubmit = async (back) => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);
        const url = "/homecare/srvey/saveUsrSrveySbmtList"
        const jToken = localStorage.getItem('jToken');
        const reqBody = buildSubmitRequest();
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                if(back) {
                    navigate(URL.HOME_CARE_MAIN, { replace: true }); // 뒤로가기 시 제출내용만 저장 (결과 x)
                }
                else{
                    handleResultSave();
                }
                
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("기록 제출 중 오류: ", err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };
    
    //설문 결과 저장
    const handleResultSave = async () => {
        const url = "/homecare/srvey/updateUsrSrveyRslt"
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const totalValue = surveyList.reduce((acc, category) => {
            return acc + category.items.reduce((subAcc, item) => {
                const val = selectedValues[item.name]?.markVal ?? 0;
                return subAcc + val;
            }, 0);
        }, 0);

        const jToken = localStorage.getItem('jToken');
        const reqBody = {
            srveyMngId: survey_data.outline.srveyMngId,
            usrInfoId: loginUser.usrInfoId,
            usrSrveyRsltId: item.usrSrveyRsltId,
            lastMarkVal: totalValue,
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setFinishOpen(false);
                setToast(true);
                setTimeout(() => {
                    navigate(URL.HOME_CARE_MAIN, { replace: true });
                }, 1200);
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("기록 제출 중 오류: ", err);
        }
    };

    // 이어서 할 step 계산
    const findFirstIncompleteStep = () => {
        for (let i = 0; i < surveyList.length; i++) {
            const category = surveyList[i];
            const hasIncomplete = category.items.some((item) => {
                const selected = selectedValues[item.name];
                return !selected || selected.markVal === -1;
            });
            if (hasIncomplete) return i + 1; // step은 1-based
        }
        return totalSteps; // 모두 완료됨 → 마지막 step
    };

    
    const handleStartSurvey = () => {
        if (step < totalSteps) {
            setStep(step + 1);
        } else if (step === totalSteps) {
             setFinishOpen(true); 
        }
    };

    // 상단 오늘 날짜 추가
    const getTodayStr = () => {
        const today = new Date();
        const yy = String(today.getFullYear()).slice(2); // 2025 → 25
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // 0~11 → 01~12
        const dd = String(today.getDate()).padStart(2, '0');
        const week = ['일', '월', '화', '수', '목', '금', '토'];
        const day = week[today.getDay()]; // 요일
        return `${yy}.${mm}.${dd}(${day})`;
    };


    // 스텝 이동시 스크롤 최상단 이동
    useEffect(() => {
        window.scrollTo({
            top: 0,
        });
    }, [step]);


    /**
     * 설문 초기화 (처음부터 클릭시! )
     */
    const initUserServeyResult = () => {

        const initUrl = "/homecare/srvey/initUserServeyResult";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
        };

        axiosApi.post(initUrl, null, { ...reqOptions,
            params: {
                usrSrveyRsltId: item?.usrSrveyRsltId
            }
            })
            .then(res => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    console.log("======> initUserServeyResult >> success !! " );
                } else {
                    console.log("======> initUserServeyResult >> failure !! " );
                }
            })
            .catch(err => {
                console.log("=============> initUserServeyResult : ", err );
            });
    };

    
    return (
        <>
            <HeadSub title={outline.title} onBack={handleBackClick}/>
 
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    {step > 0 && (
                        <div className={style['date-box']}>
                            <p>{getTodayStr()}</p>
                        </div>
                    )}     

                    {/* Progress Bar */}
                    {step >= 1 && step <= totalSteps && (
                        <div className={style["progress-box"]}>
                            <p className={style["progress-count"]}>
                                <span>{step}</span>/<span>{totalSteps}</span>
                            </p>

                            <BorderLinearProgress
                                variant="determinate"
                                value={(step / totalSteps) * 100}
                                className={style['border-linear-progress']}
                            />
                        </div>
                    )}


                    {step === 0 ? (
                        <SurveyMain data={item}/>
                    ) : step >= 1 && step <= totalSteps ? (

                        <>
                            <SurveyCheckList
                                surveyData={surveyList[step - 1]}
                                selectedValues={selectedValues}
                                onChange={handleChange}
                                numType="id"
                                />
                        </>    
                        
                    ) : null}

                
                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">

                            {step === 0 && !showIntro ? (
                                <div className="btn-layout" data-btn-num="1">
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleStartSurvey}
                                    >
                                        <span>작성 시작</span>
                                    </button>
                                </div>
                            ) : (
                                <div className="btn-layout" data-btn-num="2">
                                    <button
                                        className="btn"
                                        data-btn-type="outline-main"
                                        data-btn-size="lg"
                                        onClick={handlePre}
                                        disabled={step === 0}
                                    >
                                        <span>이전</span>
                                    </button>

                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleNext}
                                        disabled={
                                            step >= 1 &&
                                            step <= totalSteps &&
                                            !surveyList[step - 1].items.every(item => {
                                                if (item.required === false) return true; //답변 필수 아니면 true
                                                const sel = selectedValues[item.name];
                                                return sel && sel.markVal !== -1;
                                            })
                                        }
                                    >
                                        <span>
                                            {step < totalSteps
                                                ? "다음"
                                                : step === totalSteps
                                                ? "작성 완료"
                                                : null
                                            }
                                        </span>
                                    </button>
                                </div>
                            )}
                            
                        </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 

                    {toast && (
                        <ToastPopup
                        setToast={setToast}
                        message={'건강 기록 완료!'}
                        position="center"
                        opacity="90"
                        />
                    )}            
                </div>
            </div>


            {/* 제출 확인 모달 */}
            <Modal isOpen={finishOpen} setIsOpen={setFinishOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>작성 완료하시겠어요?</p>
                        </div>
                        {/* <div className="sub-box">
                            <span>모든 설문이 완료 되었습니다.</span>
                        </div> */}
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelModal}>
                                <span>아니오</span>
                            </button>
                            <button 
                                className="btn" 
                                data-btn-type="fill-main" 
                                data-btn-size="md" 
                                disabled={isLoading}
                                onClick={()=> handleSubmit(false) }
                            >
                                <span>{isLoading ? "저장 중.." : "네"}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>       


            {/* 취소 확인 모달 */}
            <Modal isOpen={backConfirmOpen} setIsOpen={setBackConfirmOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>작성을 그만하시겠어요?</p>
                        </div>
                        <div className="sub-box">
                            <span> 작성 중이던 내용은 자동으로 <br/> 임시 저장됩니다.</span>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            <button
                                className="btn"
                                data-btn-type="fill-gray"
                                data-btn-size="md"
                                onClick={() => setBackConfirmOpen(false)}
                            >
                                <span>취소</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                disabled={isLoading}
                                onClick={handleConfirmBack}
                            >
                                <span>{isLoading ? "저장 중.." : "확인"}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* 이어서 작성하기 확인 모달 */}
            <Modal isOpen={continueModalOpen} setIsOpen={setContinueModalOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>작성 중이던 내용이 있습니다.</p>
                        </div>
                        {/* <div className="sub-box">
                            <span>이전에 임시 저장된 설문 응답이 있습니다.</span>
                        </div> */}
                    </div>
                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            <button
                                className="btn"
                                data-btn-type={ item?.lastMarkVal !== undefined ? "fill-main" : "fill-gray" }
                                data-btn-size="md"
                                onClick={() => {
                                    // 새로 시작 → 기존 응답 제거  // 2026.04.23. 고수정 개편요청. 새로 작성하기시 .. 결과및 문항 초기화(소프트 DELETE)처리
                                    initUserServeyResult();
                                    setSelectedValues({});
                                    setContinueModalOpen(false);
                                    setStep(1);
                                }}
                            >
                                <span>새로 작성하기</span>
                            </button>

                            { item?.lastMarkVal === undefined &&
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={() => {
                                    const nextStep = findFirstIncompleteStep();
                                    setStep(nextStep); // 이어서 작성할 step으로 이동
                                    setContinueModalOpen(false);
                                }}
                            >
                                <span className='white-nowrap'>이어서 작성하기</span>
                            </button>
                            }

                            { item?.lastMarkVal !== undefined &&
                            <button
                                className="btn"
                                data-btn-type="fill-gray"
                                data-btn-size="md"
                                onClick={() => navigate(URL.HOME_CARE_MAIN, { replace: true })}
                            >
                                <span>취소</span>
                            </button>
                            }
                                                        
                        </div>
                    </div>
                </div>
            </Modal>

        </>
    );
};

export default Survey_26;
